import { Injectable, } from "@angular/core";
import { customAlphabet } from "nanoid";

@Injectable({
  providedIn: "root",
})
export class IdService {
  static makeID() {
    const alphabet = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    const nanoid = customAlphabet(alphabet, 32);
    return nanoid();
  }
}
